import React from 'react';
import logo from '../../images/favicons/main_logo.png';
const IconLoader = () => (
  <img id="logo" src={logo} alt="Loader Logo" />
);

export default IconLoader;
